module.exports = __webpack_public_path__ + "static/media/book.52862adf.svg";